"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Theme = void 0;
// refers to background color (not logo color):
// "dark" = light logo on dark bg; "light" = dark logo on light bg
var Theme;
(function (Theme) {
    Theme["Light"] = "light";
    Theme["Dark"] = "dark";
})(Theme = exports.Theme || (exports.Theme = {}));
//# sourceMappingURL=Theme.js.map